module.exports = __webpack_public_path__ + "static/img/SKODA.00d7b8c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos_vehicules/SKODA.png
// module id = 5IO3
// module chunks = 1